/**
 * Created by jax.luo on 2016/8/19.
 */
angular.module('dpw.services')
    .factory('markdownUtils', ['helpers', function (helpers) {
        'use strict';

        return {
            md2Html: md2Html,
            html2Md: html2Md
        };


        function md2Html(mdString) {
            var md = window.markdownit("commonmark", {
                html: true,
                linkify: true,
                breaks: true
            });

            // override the "a" open tag
            md.renderer.rules.link_open = function (tokens, index) {

                var attrs = {};
                _.forEach(tokens[index].attrs, function (val) {
                        attrs[val[0]] = val[1];
                    }
                );

                _.extend(attrs, helpers.getFormattedLinkAttrs(attrs['href']));

                var html = '<a';
                _.forEach(attrs, function (val, key) {
                    html += ' ' + key + '="' + val + '"';
                });

                html += '>';

                return html;
            };
            md.renderer.rules.image = function () {
                return '';
            };

            // 3 steps:
            // (1) htmlEncode html
            // (2) render md to html
            // (3) handle br tag
            return decodeBr(md.render(htmlEncode(mdString)));
        }

        function html2Md(html) {

            // if html has no text, return empty string
            if (htmlDecode(html) === "") {
                return "";
            }

            var options = {
                converters: [{
                    filter: ['b', 'strong'],
                    replacement: function (content, node) {
                        var postfix = "**";
                        // fix consecutive b or strong will create ****
                        var tagName = node.nextElementSibling && node.nextElementSibling.tagName.toLowerCase();
                        if (['b', 'strong'].indexOf(tagName) > -1) {
                            postfix += ' ';
                        }
                        return '**' + content + postfix;
                    }
                }, {
                    filter: ['i', 'em'],
                    replacement: function (content, node) {
                        var postfix = "_";
                        // fix consecutive i or em will create __
                        var tagName = node.nextElementSibling && node.nextElementSibling.tagName.toLowerCase();
                        if (['i', 'em'].indexOf(tagName) > -1) {
                            postfix += ' ';
                        }
                        return '_' + content + postfix;
                    }
                }]
            };

            return toMarkdown(encodeBr(html), options);
        }


        function encodeBr(html) {
            return html.replace(/<br>/g, '[br]');
        }

        function decodeBr(html) {
            return html.replace(/\[br]/g, '<br>');
        }

        function htmlEncode(s) {
            var div = document.createElement('div');
            div.appendChild(document.createTextNode(s));

            // because the markdown syntax "> " will be encoded, so need to decode it
            return div.innerHTML.replace(/&gt; /g, '> ');
        }

        function htmlDecode(s) {
            var div = document.createElement('div');
            div.innerHTML = s;
            return (div.innerText || div.textContent || "").trim();
        }
    }]);